import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { FaUser } from 'react-icons/fa';

import BotAvatar from './BotAvatar';
import { CustomBotIconContext, useSession } from '../context';
import { CustomBotIcon } from './CustomBotIcon';

/** Show Bot Icon
 * - Custom Icon uploaded to Firebase Storage (if any)
 * - User icon if live chat & no custom icon
 * - Robot icon if bot mode & no custom icon
 */
export function ChatWindowIcon() {
  const { status, url } = useContext(CustomBotIconContext);
  const { site, conversation } = useSession();

  const { botConfig } = site;
  const { botIcon, primaryColor } = botConfig;

  /** Even if current mode is live chat, we will still show a custom
   * bot icon if there is one. */
  const isHuman =
    conversation.value.conversationMode === 'liveChatSMS' ||
    conversation.value.conversationMode === 'liveChatWeb';

  if (status === 'loading') {
    return null;
  }

  const iconIsReady = Boolean(botIcon && url && status === 'success');

  return (
    <Container
      bg={iconIsReady ? primaryColor : 'white'}
      color={isHuman ? primaryColor : null}
    >
      {iconIsReady ? (
        <CustomBotIcon url={url} />
      ) : isHuman ? (
        <FaUser />
      ) : (
        <BotAvatar />
      )}
    </Container>
  );
}

/** Wrapper for Icon, including while border */
const Container = styled.div<{ bg: string; color: string }>`
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  background-color: ${props => props.bg};
  color: ${props => props.color};
  border: 3px solid white;
  border-radius: 50%;
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 2; // makes custom icon transition work correctly
`;
